import { render } from "./CourseNavigationTabs.vue?vue&type=template&id=60f9607e&scoped=true"
import script from "./CourseNavigationTabs.vue?vue&type=script&lang=js"
export * from "./CourseNavigationTabs.vue?vue&type=script&lang=js"

import "./CourseNavigationTabs.vue?vue&type=style&index=0&id=60f9607e&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f9607e"]])

export default __exports__